export class DiaryFormRuleTranslation {
  public id: string;
  public diaryFormRuleId: string;
  public culture: string;
  public messageText: string;
  public emailText: string;
  public emailSubject: string;

  constructor(init?: Partial<DiaryFormRuleTranslation>) {
    Object.assign(this, init);
  }
}
